export default `<div class="card"></div>

<style>
    .card {
        background-color: var(--svea-card-bg, #ffffff);
        border: 1px solid var(--svea-card-border-color, #cbcbcb);
        border-radius: var(--svea-card-radius-base, 0.625rem);
        box-shadow: none;
    }

    .card.shadow-small {
        box-shadow: var(
            --svea-card-shadow-sm,
            0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.16)
        );
    }

    .card.shadow-medium {
        box-shadow: var(
            --svea-card-shadow-md,
            0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.25)
        );
    }

    .card.shadow-large {
        box-shadow: var(
            --svea-card-shadow-lg,
            0 0.25rem 0.625rem 0 rgba(0, 0, 0, 0.4)
        );
    }

    .card.radius-none {
        border-radius: 0rem;
    }

    .card.radius-small {
        border-radius: var(--svea-card-radius-sm, 0.25rem);
    }

    .card.radius-medium {
        border-radius: var(--svea-card-radius-md, 1.25rem);
    }

    .card.radius-large {
        border-radius: var(--svea-card-radius-lg, 2rem);
    }

    .card.blue {
        background-color: var(--svea-card-bg-info, #e8f6f9);
    }

    .card.border-dark {
        border-color: var(--svea-card-border-color-dark, #949494);
    }

    ::slotted(.svea-card-info-row) {
        padding: 1rem 1.25rem;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #dfdfdf;
    }

    ::slotted(.svea-card-info-row-column) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-top: 1px solid #dfdfdf;
    }
</style>
`